import React from 'react';

const LoadingSpinner: React.FC<{ className?: string }> = ({ className }) => (
  <svg 
    viewBox="0 0 50 50" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={{ animation: 'spin 2s linear infinite' }}
  >
    <circle
      cx="25"
      cy="25"
      r="20"
      stroke="#e9ecef"
      strokeWidth="4"
      fill="none"
    />
    <circle
      cx="25"
      cy="25"
      r="20"
      stroke="rgb(223, 252, 104)"
      strokeWidth="4"
      fill="none"
      strokeLinecap="round"
      strokeDasharray="31.416"
      strokeDashoffset="23.562"
    />
    <circle
      cx="25"
      cy="25"
      r="12"
      stroke="#6c757d"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeDasharray="18.85"
      strokeDashoffset="14.138"
      style={{ animationDelay: '0.3s' }}
    />
  </svg>
);

export default LoadingSpinner;